<script>
    import {onMount} from "svelte";
    import gsap from "gsap";
    import SplitText from 'gsap/SplitText';
    import {getEndLabel, getStartLabel, labels, mainTimeline} from "../../timelines/main-timeline";

    gsap.registerPlugin(SplitText);

    const titleDuration = 4;

    const {gnosisStart} = labels;

    const getInsertionPoint = (labelIndex, delay) => getStartLabel(labelIndex) + '+=' + delay;

    const titles = [
        [],
        [],
        [],
        // Scene 2
        [
            {
                text: 'Welcome to the new customer journey',
                insertionPoint: getStartLabel(1),
            },
            {
                text: 'I’m Gnosis, and I’ll be your guide',
                insertionPoint: getInsertionPoint(1, titleDuration),
            }
        ],
        // Scene 3
        [
            {
                text: 'Today’s leaders actively seek out thought leadership that provides fresh thinking about their challenges',
                insertionPoint: getStartLabel(2),
            }
        ],
        // Scene 4
        [
            {
                text: '88% of business leaders spend a significant amount of time researching companies before inviting them to present or pitch',
                insertionPoint: getStartLabel(3),
            }
        ],
        // Scene 5
        [
            {
                text: 'On average, companies bring together nine executives to decide on strategic deals',
                insertionPoint: getStartLabel(4),
            }
        ],
        // Scene 6
        [
            {
                text: 'Decision-makers are most likely to engage with your content if it addresses their specific problems',
                insertionPoint: getStartLabel(5),
            }
        ],
        // Scene 7
        [
            {
                text: '40% of business leaders say that thought leadership is very important when they are deciding who to shortlist for a tender',
                insertionPoint: getStartLabel(6),
            }
        ],
        // Scene 8
        [
            {
                text: 'Business leaders use thought leadership to assess',
                insertionPoint: getStartLabel(7),
            },
            {
                text: 'innovative thinking, your vision for the future and the quality of your talent',
                insertionPoint: getInsertionPoint(7, titleDuration),
            }
        ],
        // Scene 9
        [
            {
                text: 'Almost half of business leaders say you need strong ESG credentials to win the tender',
                insertionPoint: getStartLabel(8),
            }
        ],
        // Scene 10
        [
            {
                text: '45% of business leaders strongly agree that thought leadership has influenced their decision to award business to a supplier',
                insertionPoint: getStartLabel(9),
            }
        ],
        // Scene 11
        [
            {
                text: 'We’ve reached our destination',
                insertionPoint: getStartLabel(10),
            },
            {
                text: 'As you can see, your customers face many challenges as they choose the right strategic partner',
                insertionPoint: getInsertionPoint(10, titleDuration),
            },
            {
                text: 'But your thought leadership can help them to navigate that journey',
                insertionPoint: getInsertionPoint(10, titleDuration * 2),
            }
        ],
        // Scene 12
        [
            {
                text: 'Download our guide for the full story of how thought leadership can accelerate your customer’s journey ',
                insertionPoint: getStartLabel(11),
            }
        ],
    ];

    const timeline = gsap.timeline();

    onMount(() => {


        titles.forEach((titleGroup, sceneIndex) => {
            let previousDuration = 0;

            titleGroup.forEach(({text}, titleIndex) => {

                const selector = '.title' + sceneIndex + '_' + titleIndex;

                if (Boolean(text)) {
                    const textLength = text.length;
                    const stagger = 0.05;
                    const subtitleDuration = textLength * stagger + 0.6;

                    const insertionPoint = Boolean(previousDuration) ? getInsertionPoint(sceneIndex, previousDuration) : getStartLabel(sceneIndex);
                    const endPoint = titleIndex + 1 === titleGroup.length ? getEndLabel(sceneIndex) : '>+=' + subtitleDuration ;

                    mainTimeline.from(selector, {
                        autoAlpha: 0,
                        duration: 0.15,
                    }, insertionPoint)

                    mainTimeline.to(selector, {
                        autoAlpha: 0,
                        duration: 0.15,
                    }, endPoint);

                    const splitText = new SplitText(selector, {type: 'words, chars'});

                    mainTimeline.from(splitText.chars, {
                        autoAlpha: 0,
                        stagger,
                        duration: 0.001,
                    }, insertionPoint)

                    previousDuration = previousDuration + subtitleDuration + 0.7
                }

            });
            previousDuration = 0;
        });

        mainTimeline.add(timeline, 0);
    });

</script>

<div class="subtitle-container">
    <div class="inner-container">
        {#each titles as group, i}
        {#each group as title, i2}
            {#if Boolean(title.text)}
                <h2 class={`title title${i}_${i2}`}>{title.text}</h2>
            {/if}
        {/each}
        {/each}
    </div>
</div>

<style>
    .subtitle-container {
        position: relative;
        top: 100px;
        left: 0;
        right: 0;
        z-index: 5;
        pointer-events: none;
    }

    .inner-container {
        position: relative;
        margin: 0 auto;
        max-width: 800px;
    }

    .title {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        text-align: center;
        margin: 0 auto;
        padding: 0 20px;
        font-size: 32px;
        font-family: 'Metric', sans-serif;
        font-weight: 300;
        color: #00A0DD;
        line-height: 1.4;
        letter-spacing: 1px;
    }

    @media (max-width: 639px) {
        .title {
            top: 200px;
            font-size: 16px;
            font-weight: 400;
            padding: 0 1rem;
        }
    }

    @media screen and (max-height: 799px) {
        .subtitle-container {
            transform: scale(0.8);
            transform-origin: top center;
        }
    }

    @media screen and (max-width: 1200px) {
        .subtitle-container {
            transform: scale(0.8);
            transform-origin: top center;
        }
    }

</style>